import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "/",
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = {
        ...config.headers,
        authorization: `Token ${token}`
      };
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
